<!-- eslint-disable vue/no-v-html -->
<!-- it's okay to skip sanitizing because we don't modify received values, so there's no way for the user input to sneak in -->
<template>
  <a
    class="help-center-search-result__link"
    :href="result.url"
    @click="close"
  >
    <div class="help-center-search-result__columns">
      <HelpCenterSearchIcon
        class="help-center-search-result__icon"
        :result="result"
      />
      <div class="help-center-search-result__info">
        <p
          class="help-center-search-result__title"
          v-html="result.html_title"
        />
        <p
          class="help-center-search-result__summary"
          v-html="result.html_summary"
        />
      </div>
    </div>
  </a>
</template>

<script setup>
import isLeftClick from 'gleam-shared/browser/isLeftClick'
import HelpCenterSearchIcon from 'help-center/components/HelpCenterSearchIcon'

const emit = defineEmits(['close'])

defineProps({
  result: {
    type: Object,
    required: true
  }
})

function close(event) {
  if (isLeftClick(event)) {
    emit('close')
  }
}
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-search-result {
  &__link {
    @include help-center-accent-link($selector: '.help-center-search-result__title');
  }

  &__columns {
    gap: 12px;
    display: flex;
  }

  &__icon {
    flex: none;
  }

  &__title {
    @include help-center-font(16);
  }

  &__summary {
    @include help-center-font(14);
    color: var(--help-center-muted);
  }
}
</style>
